import React, {Fragment, useRef, useState} from 'react';
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import ListEdit from "../UI/ListEdit";
import ModalFormInputRow from "../UI/ModalFormInputRow";
import ModalForm from "../UI/ModalForm";
import ModalFormInputsContainer from "../UI/ModalFormInputsContainer";
import Box from "../UI/Box";
import {toast} from "react-toastify";
import {useUnattendedAccessTermsVersions} from "../../hooks/useUnattendedAccessTermsVersions";
import {createUnattendedAccessTermsVersion} from "../../api/unattendedAccessTermsVersionApiClient";
import {convertToDisplayDateTime} from "../../utility/utility";

const UnattendedAccessTermsVersionList = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [viewingTerm, setViewingTerm] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [submitCount, setSubmitCount] = useState(0);
    const titleRef = useRef(null);
    const textRef = useRef(null);
    const {unattendedAccessTermsVersions, pagination} = useUnattendedAccessTermsVersions(page, pageSize, submitCount);

    const termsVersionList = unattendedAccessTermsVersions.map((item, index) => ({
        ...item,
        idDisplay : (
            <Fragment>
                {item.id}
                {page === 1 && index === 0 && (
                    <span className="ml-2 inline-block bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">Current</span>
                )}
            </Fragment>
        ),
        createdAt : convertToDisplayDateTime(item.createdAt)
    }));

    const handleCreateButtonClick = () => {
        setShowModal(true)
    }

    const handleCreateSubmit = (event) => {
        event.preventDefault();

        const title = titleRef.current.value;
        const text = textRef.current.value;

        createUnattendedAccessTermsVersion(title, text)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const handleShowIconClick = (unattendedAccessTermsVersionId) => {
        const term = unattendedAccessTermsVersions.find(item => item.id === unattendedAccessTermsVersionId);
        setViewingTerm(term);
    }

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'ID',
        'Title',
        'Created At',
        'Actions'
    ];

    const columns = {
        functionParams : ['id'],
        dataKeys       : [
            'idDisplay',
            'title',
            'createdAt'
        ],
    }

    return (
        <Fragment>
            <Box>
                <Button title='Publish new version' handleClick={handleCreateButtonClick}/>
                <ListEdit
                    headers={listHeaders}
                    items={termsVersionList}
                    columns={columns}
                    pagination={pagination}
                    handleShowIconClick={handleShowIconClick}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
            {showModal && (
                <Modal>
                    <form onSubmit={handleCreateSubmit}>
                        <ModalForm
                            title='Publish new version'
                            saveButtonTitle='Publish'
                            handleCancelButtonClick={() => setShowModal(false)}
                        >
                            <ModalFormInputRow title='Title'>
                                <input
                                    ref={titleRef}
                                    type="text"
                                    id="title"
                                    name="title"
                                    placeholder="Enter title"
                                    className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline"
                                />
                            </ModalFormInputRow>
                            <ModalFormInputRow title='Text'>
                                <textarea
                                    ref={textRef}
                                    id="text"
                                    name="text"
                                    rows={10}
                                    placeholder="Enter legal text"
                                    className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline"
                                />
                            </ModalFormInputRow>
                        </ModalForm>
                    </form>
                </Modal>
            )}
            {viewingTerm && (
                <Modal>
                    <ModalFormInputsContainer title={viewingTerm.title} onClose={() => setViewingTerm(null)}>
                        <p className="text-sm text-gray-500 mb-4">ID {viewingTerm.id} &middot; {convertToDisplayDateTime(viewingTerm.createdAt)}</p>
                        <p className="whitespace-pre-wrap text-gray-700">{viewingTerm.text}</p>
                    </ModalFormInputsContainer>
                    <div className="bg-gray-50 rounded-b-2xl px-6 py-4 flex justify-end">
                        <Button color="black" bgColor="white" title="Close" handleClick={() => setViewingTerm(null)}/>
                    </div>
                </Modal>
            )}
        </Fragment>
    );
}

export default UnattendedAccessTermsVersionList;
